import { render, staticRenderFns } from "./UKSince.vue?vue&type=template&id=3a1954c0"
import script from "./UKSince.vue?vue&type=script&lang=js"
export * from "./UKSince.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports